import { memoize } from 'lodash-es';

import { FavoriteFieldType } from 'core/graphql';

export interface FavoriteField {
  applyToAllObjectTypes: boolean;
  associatedObjectTypes: string[];
  fieldName: string;
  fieldType: FavoriteFieldType;
  id: string;
}

export type MatchingFavoriteField = Pick<
  FavoriteField,
  'fieldName' | 'fieldType' | 'id'
>;

export const getApplicableFavoriteFields = memoize(
  (
    favoriteFields: FavoriteField[],
    fieldType: FavoriteFieldType,
    objectType?: string
  ) => {
    const matches: MatchingFavoriteField[] = [];

    favoriteFields?.forEach(
      ({
        fieldName,
        fieldType: currentFieldType,
        id,
        applyToAllObjectTypes,
        associatedObjectTypes,
      }) => {
        const match =
          currentFieldType === fieldType &&
          (applyToAllObjectTypes ||
            (objectType && associatedObjectTypes.includes(objectType)));

        if (match) {
          matches.push({ fieldName, fieldType: currentFieldType, id });
        }
      }
    );

    return matches;
  }
);
